import { render, staticRenderFns } from "./PrenotazioniMenu.vue?vue&type=template&id=f04162ac&"
import script from "./PrenotazioniMenu.vue?vue&type=script&lang=js&"
export * from "./PrenotazioniMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports